import {NullMessageId} from '@github-ui/copilot-chat-types'
import type {OptionConfig} from '@github-ui/issue-viewer/OptionConfig'

import type {Issue} from './content-preview-types'
import type {ContentPreviewActions} from './ContentPreviewContext'

type SubIssue = Parameters<NonNullable<OptionConfig['onSubIssueClick']>>[0]

export function openIssueInNewTab(url: string) {
  window.open(url, '_blank', 'noopener,noreferrer')
}

export function openSubIssueInWorkbench(
  subIssue: SubIssue,
  {
    updateItem,
    openItem,
    contentPreviewRef,
  }: Pick<ContentPreviewActions, 'updateItem' | 'openItem' | 'contentPreviewRef'>,
) {
  const issueItem: Issue = {
    type: 'issue',
    id: `issue:${subIssue.owner}/${subIssue.repo}/${subIssue.number}`,
    messageId: NullMessageId,
    name: subIssue.title,
    owner: subIssue.owner,
    repo: subIssue.repo,
    number: subIssue.number,
    href: subIssue.url,
    state: subIssue.state.toLowerCase() === 'closed' ? 'closed' : 'open',
  }

  updateItem(issueItem)
  openItem(issueItem.id)
  requestAnimationFrame(() => {
    contentPreviewRef.current?.querySelector<HTMLElement>('[role="tab"][aria-selected="true"]')?.focus()
  })
}
